import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';

import TicketSkeleton from '@common/components/ticketSkeleton';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';

const WithdrawalConfirmPopup = ({ betshop, result }) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small w-a-wrapper">
      <h3 className="popup-title">{t('Withdrawal Amount')}</h3>
      <TicketSkeleton dark>
        <div className="ticket-section">
          <div className="ticket-info-row">
            <p>{t('Date')}</p>
            {moment(result.Date * 1000).format('DD-MM-YYYY HH:mm')}
          </div>
          <div className="ticket-info-row">
            <p>{t('Transaction id')}</p>
            {result.Id}
          </div>
          <div className="ticket-info-row">
            <p>{t('Betshop')}</p>
            {betshop.name}
          </div>
        </div>
        <div className="ticket-section">
          <div className="ticket-info-row">
            <p>{t('Withdrawal amount')}</p>
            <span className="w-c-p-amount">{result.Amount}</span>
          </div>
        </div>
      </TicketSkeleton>
      <button type="button" className="popup-cancel-button w-c-p-close" onClick={closePopup}>{t('Close')}</button>
    </div>
  );
};

export default WithdrawalConfirmPopup;

WithdrawalConfirmPopup.propTypes = {
  result: PropTypes.object,
  betshop: PropTypes.object,
};
